import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Остальные продукты',
} satisfies TMessages
